<div class="page-container">
  <div class="padding-top-13 pos-rel">
    <button *ngIf="(validWidgets | widgetConfig: 100)"  class="primary-button profile-change-image-button upload-button button-hover-effect "
    [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
    [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('CAMPAIGN_PAGE.EDIT' | i18nTranslate)"
    [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
      (click)="addNewCustomer()">
      {{ "CUSTOMER_PAGE.ADD_NEW_CUSTOMER" | i18nTranslate }}
    </button>
    <div class="search-container">
      <input #search type="text" placeholder="Search by Customer Name/Number/Email"
        (input)="onKeySearch(search.value, true)" />
      <span class="material-icons icons-primary huge-icon" *ngIf="search.value.length==0"> search </span>
      <span class="material-icons icons-primary cursor-pointer huge-icon" *ngIf="search.value.length>0"
        (click)="search.value='';onKeySearch(search.value, true)">
        close
      </span>
    </div>
  </div>

  <div class="total-customer-count"> {{'SEGMENT_PAGE.TOTAL_CUSTOMER' | i18nTranslate}} : <span
      class="count-text">{{overallTotalCustomers}}</span></div>
  <div class="main-list-container-2 main-white-panel pos-rel">
    <div class="list-column-header-row-2" #headerContainer>
      <div class="col-header">
        {{'PROFILE_PAGE.NAME' | i18nTranslate}}
      </div>
      <div class="col-header wide-column-width">
        {{'PROFILE_PAGE.EMAIL' | i18nTranslate}}
      </div>
      <div class="col-header medium-col-width">
        {{'PROFILE_PAGE.PHONE' | i18nTranslate}}
      </div>
      <div class="col-header medium-col-width">
        {{ "CUSTOMER_PAGE.SUBSCRIPTION_TIER" | i18nTranslate }}
      </div>
      <div class="col-header medium-col-width">
        {{ "CUSTOMER_PAGE.STATUS" | i18nTranslate }}
      </div>
      <div class="col-header medium-col-width">
        {{ "CUSTOMER_PAGE.START_DATE" | i18nTranslate }}
      </div>
      <div class="col-header medium-col-width">
        {{ "CUSTOMER_PAGE.END_DATE" | i18nTranslate }}
      </div>
    </div>
    <div class="main-list-2" #contentContainer>
      <div class="list-loader-container" *ngIf="loading">
        <app-qubriux-loading [size]="65" [loadingText]="'Fetching your customers...'"></app-qubriux-loading>
      </div>
      <div *ngIf="!loading && customers.length == 0" class="empty-list-indicator">
        No Customers Found
      </div>
      <div *ngIf="!loading && customers.length > 0">
        <div *ngFor="let customer of customers" class="list-item-row-2" (click)="openCustomerDetailsDialog(customer)">
          <div class="list-item">
            <div class="list-item-content" [matTooltip]="customer.customerName">{{ customer["firstName"] || '----'}}
            </div>
          </div>
          <div class="list-item wide-column-width">
            <div class="list-item-content" [matTooltip]="customer.email">{{ customer["emailAddress"] || '----'}}</div>
          </div>
          <div class="list-item medium-col-width">
            <div class="list-item-content" [matTooltip]="customer.phone">{{ customer["mobileNumber"] || '----'}}</div>
          </div>
          <div class="list-item medium-col-width">
            <div class="list-item-content">
              {{ customer["subscriptionName"] || '----'}}
            </div>
          </div>
          <div class="list-item medium-col-width">
            <div class="list-item-content">
              <span class="status-bubble" [ngClass]="getStatusClass(customer['status'])">{{ customer['status'] || '----'
                }}</span>
            </div>
          </div>
          <div class="list-item medium-col-width">
            <div class="list-item-content">{{ getDateInFormatForDisplay(customer["subscriptionStartDate"]) || '----'}}
            </div>
          </div>
          <div class="list-item medium-col-width">
            <div class="list-item-content">{{ getDateInFormatForDisplay(customer["subscriptionEndDate"]) || '----'}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lv-options-2">
      <mat-paginator [pageIndex]="pageIndex - 1" [length]="totalCustomers" [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]" (page)="refreshPaginatedData($event)">
      </mat-paginator>
    </div>
  </div>
</div>